// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration - replace with your actual Firebase project details
const firebaseConfig = {
    apiKey: "AIzaSyBG6WPJSTZ_5eMVJEjIOBQG9NBN7PVNRDc",
    authDomain: "zonexweb-1c842.firebaseapp.com",
    projectId: "zonexweb-1c842",
    storageBucket: "zonexweb-1c842.firebasestorage.app",
    messagingSenderId: "135197446399",
    appId: "1:135197446399:web:57116ddef09af00ccd3cca",
    measurementId: "G-EZL430Q86P"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };